export const aggregatefunction = {
    Count: 'count',
    Average: 'avg',
    Sum: 'sum',
    Max: 'max',
    Min: 'min'
}

export const rollupFilterRules = {
    text: {
        equals: 1,
        empty: 2
    },
    check: {
        enabled: 3,
        disabled: 4,
        indeterminate: 5
    },
    number: {
        equals: 6,
        more: 7,
        less: 8,
        between: 9,
        empty: 10
    },
    linkedField: {
        equals: 11,
        empty: 12
    }
}
